module.exports = __webpack_public_path__ + "static/media/sorting.e9c1238b.png";